import { getTheme } from 'settings/theme/index';
import styled from 'styled-components';

const {
  noodera: { fontTypes },
} = getTheme();

const NoodleInput = (ComponentName) => styled(ComponentName)`
  &&& {
    ${fontTypes.font4};
    border-radius: 0.4rem;
    /* Remove outline added by Reactstrap */
    box-shadow: none;
    height: 4.2rem;

    &.input-onboarding {
      height: 5.1rem;
      font-size: 1.6rem;
    }
  }
`;

export default NoodleInput;
